import BaseModel from "../../../common/model/base_model";

export default class SecondFactorLoginModel extends BaseModel {

    provider = '';
    code = '';
    // output parameters
    redirect_url = '';
    force_reload = false;

}